import type { MouseEvent } from 'react';

type Props = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
  /** How many page number buttons to show (legacy `pageRangeDisplayed`). */
  range?: number;
};

const pageWindow = (page: number, total: number, range: number): number[] => {
  if (total <= range) return Array.from({ length: total }, (_, i) => i + 1);
  const half = Math.floor(range / 2);
  let start = Math.max(1, page - half);
  let end = start + range - 1;
  if (end > total) {
    end = total;
    start = Math.max(1, end - range + 1);
  }
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

/** Always rendered (like legacy), even for a single empty page. Prev/next use ⟨ ⟩. */
export const Pagination = ({ page, totalPages, onChange, range = 5 }: Props) => {
  const pages = Math.max(1, totalPages || 1);
  const current = Math.min(Math.max(1, page), pages);
  const numbers = pageWindow(current, pages, range);

  const go =
    (next: number) =>
    (e: MouseEvent) => {
      e.preventDefault();
      if (next >= 1 && next <= pages && next !== current) onChange(next);
    };

  return (
    <div className="box-footer clearfix">
      <ul className="pagination pagination-sm no-margin pull-right">
        <li className={current <= 1 ? 'disabled' : undefined}>
          <a href="#" onClick={go(1)} aria-label="Первая">
            «
          </a>
        </li>
        <li className={current <= 1 ? 'disabled' : undefined}>
          <a href="#" onClick={go(current - 1)} aria-label="Предыдущая">
            ⟨
          </a>
        </li>
        {numbers.map((n) =>
          n === current ? (
            <li key={n} className="active">
              <span>{n}</span>
            </li>
          ) : (
            <li key={n}>
              <a href="#" onClick={go(n)}>
                {n}
              </a>
            </li>
          ),
        )}
        <li className={current >= pages ? 'disabled' : undefined}>
          <a href="#" onClick={go(current + 1)} aria-label="Следующая">
            ⟩
          </a>
        </li>
        <li className={current >= pages ? 'disabled' : undefined}>
          <a href="#" onClick={go(pages)} aria-label="Последняя">
            »
          </a>
        </li>
      </ul>
    </div>
  );
};
